import React, { forwardRef} from "react";
import { Container } from "react-bootstrap";

const PassportListPrint = forwardRef((props, ref) => {

  return (
    <>
        <div ref={ref}
        style={{
            marginLeft: "30px",
            marginRight: "30px",
            marginTop: "30px",
            marginBottom: "30px",
        }}
        >
          <table
            style={{
              width: "100%",
              cellpadding: "0",
              cellspacing: "0",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <tr
              style={{
                border: "0",
                width: "100%",
                cellpadding: "0",
                cellspacing: "0",
                textAlign: "center",
              }}
            >
              <td
                style={{
                  border: "0",
                  width: "25%",
                  cellpadding: "0",
                  cellspacing: "0",
                  textAlign: "left",
                }}
              >
                <table
                  style={{
                    border: "0",
                    width: "25%",
                    cellpadding: "0",
                    cellspacing: "0",
                  }}
                >
                  <tr>
                    <td>
                      <img
                        style={{ maxHeight: "80px", maxWidth: "200px" }}
                        src="./img/logo.png"
                      />
                    </td>
                  </tr>
                </table>
              </td>
              <td
                style={{
                  border: "0",
                  width: "50%",
                  cellpadding: "0",
                  cellspacing: "0",
                  textAlign: "center",
                }}
              ></td>
              <td
                style={{
                  border: "0",
                  width: "25%",
                  cellpadding: "0",
                  cellspacing: "0",
                  textAlign: "right",
                }}
              >
                <p>
                  Gulfesha Plaza, 12/0
                  <br />
                  69 Outer Circular Road
                  <br />
                  Boro Mogbazar, Dhaka-1217
                  <br />
                  +880241031411-2
                  <br />
                  info@northeastoverseas.com
                  <br />
                </p>
              </td>
            </tr>
          </table>
          <br />
          <table
            style={{
              width: "100%",
              cellpadding: "0",
              cellspacing: "0",
            }}
          >
            <tr
              style={{
                border: "0",
                width: "100%",
                cellpadding: "0",
                cellspacing: "0",
                textAlign: "center",
              }}
            >
              <td
                style={{
                  border: "0",
                  width: "100%",
                  cellpadding: "0",
                  cellspacing: "0",
                  alignItems: "center",
                }}
              >
                <h4 style={{ color: "black" }}>Passport Information</h4>
              </td>
            </tr>
          </table>

          <table>
            <th 
            style={{
              paddingLeft: "40px",
            }}
            className="text-black fw-bold">
              Agent: {props.passportList[0].agent}
            </th>
          </table>

          {/* Data table */}
          <table
            style={{
              width: "92%",
              cellpadding: "0",
              cellspacing: "0",
              marginLeft: "30px",
              marginRight: "30px",
              marginTop: "30px",
              marginBottom: "30px",
              border: "1px solid black",
              borderCollapse: "collapse",
              color: "black",
            }}
          >
            {/* Table Header */}
            <tr
              style={{
                border: "0",
                width: "50%",
                cellpadding: "0",
                cellspacing: "0",
                textAlign: "center",
                color: "black",
                border: "1px solid black",
                borderCollapse: "collapse",
              }}
            >
              <th style={{ padding: "6px", border: "1px solid black" }}>Name</th>
              <th style={{ padding: "6px", border: "1px solid black" }}>Passport No.</th>
              <th style={{ padding: "6px", border: "1px solid black" }}> Agent </th>
              <th style={{ padding: "6px", border: "1px solid black" }}> Country </th>
              
              <th style={{ padding: "6px", border: "1px solid black" }}>Contract Amount</th>
              <th style={{ padding: "6px", border: "1px solid black" }}>Paid Amount</th>
              <th style={{ padding: "6px", border: "1px solid black" }}>Due Amount</th>
              <th style={{ padding: "6px", border: "1px solid black" }}> 
              Delivery Office
              </th>
              <th style={{ padding: "6px", border: "1px solid black" }}> Status</th>
            </tr>

            {props.passportList.map((passport) => (
              <>
                <tr
                  key={passport._id}
                  style={{
                    border: "0",
                    width: "50%",
                    cellpadding: "0",
                    cellspacing: "0",
                    textAlign: "center",
                    // key: {props.employee._id}
                  }}
                >
                    <td style={{ padding: "4px", border: "1px solid black" }}>{passport.fullName}</td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>{passport.passportNumber}</td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>{passport.agent}</td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>{passport.country}</td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>{passport.contractAmount}</td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>{passport.paidAmount}</td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>{passport.contractAmount - passport.paidAmount}</td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>{passport.deliveryOffice}</td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>{passport.status}</td>
                </tr>
              </>
            ))}
          </table>

          <table
            style={{
              width: "80%",
              border: "0",
              cellpadding: "0",
              cellspacing: "0",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "50px",
            }}
          >
            <hr
              style={{
                border: "1px solid black",
                width: "100%",
              }}
            />
          </table>

          <table
            style={{
              width: "80%",
              border: "0",
              cellpadding: "0",
              cellspacing: "0",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <tr
              style={{
                border: "0",
                width: "50%",
                cellpadding: "0",
                cellspacing: "0",
                textAlign: "center",
              }}
            >
              <th
                colspan="2"
                style={{
                  border: "0",
                  width: "50%",
                  cellpadding: "0",
                  cellspacing: "0",
                  textAlign: "center",
                }}
              >
                <p style={{ color: "black" }}>
                  @Copyright 2024 NORTHEAST OVERSEAS. All rights reserved.
                </p>
              </th>
            </tr>
          </table>
        </div>
    </>
  );
});

export default PassportListPrint;
